import type { Assistant } from './assistants.types';

export const defaultAssistantConfig: Partial<Omit<Assistant, 'name'>> = {
  model: {
    messages: [{
      content: '',
      role: 'system'
    }],
    temperature: 0.7,
    maxTokens: 250,
    numFastTurns: 0,
    semanticCachingEnabled: false,
    emotionRecognitionEnabled: true,
    toolIds: []
  },
  voice: {
    fillerInjectionEnabled: false,
    style: 0,
    voiceId: 'Robert',
    language: 'en',
    stability: 0.5,
    speed: 1,
    similarityBoost: 0.75,
    useSpeakerBoost: false,
    enableSsmlParsing: false,
    optimizeStreamingLatency: 1,
    chunkPlan: {
      enabled: true,
      minCharacters: 50,
      punctuationBoundaries: ['.', '?', '!'],
      formatPlan: {
        enabled: true,
        numberToDigitsCutoff: 10,
        replacements: []
      }
    }
  },
  firstMessageMode: 'assistant-waits-for-user',
  hipaaEnabled: false,
  clientMessages: [],
  serverMessages: ["end-of-call-report"],
  silenceTimeoutSeconds: 10,
  maxDurationSeconds: 600,
  backgroundSound: 'off',
  backchannelingEnabled: false,
  backgroundDenoisingEnabled: false,
  modelOutputInMessagesEnabled: true,
  transportConfigurations: [{
    provider: 'twilio',
    timeout: 30,
    record: true,
    recordingChannels: 'mono'
  }],
  firstMessage: '',
  voicemailDetection: {
    enabled: false,
    provider: 'twilio',
    machineDetectionTimeout: 30,
    voicemailDetectionTypes: [],
    machineDetectionSilenceTimeout: 10000,
    machineDetectionSpeechThreshold: 3500,
    machineDetectionSpeechEndThreshold: 1000
  },
  voicemailMessage: '',
  endCallMessage: 'Goodbye!',
  endCallPhrases: [],
  metadata: {},
  analysisPlan: {
    summaryPrompt: '',
    summaryRequestTimeoutSeconds: 10,
    structuredDataPrompt: '',
    structuredDataSchema: {
      type: 'object',
      properties: {},
      required: []
    },
    structuredDataRequestTimeoutSeconds: 10,
    successEvaluationPrompt: '',
    successEvaluationRubric: 'NumericScale',
    successEvaluationRequestTimeoutSeconds: 10
  },
  artifactPlan: {
    transcriptPlan: {
      enabled: true,
      userName: 'User',
      assistantName: 'Assistant'
    },
    recordingEnabled: true,
    videoRecordingEnabled: false,
    recordingPath: ''
  },
  messagePlan: {
    idleMessages: [],
    idleMessageMaxSpokenCount: 3,
    idleTimeoutSeconds: 7.5
  },
  startSpeakingPlan: {
    waitSeconds: 0.4,
    smartEndpointingEnabled: false,
    transcriptionEndpointingPlan: {
      onPunctuationSeconds: 0.1,
      onNoPunctuationSeconds: 1.5,
      onNumberSeconds: 0.5
    }
  },
  stopSpeakingPlan: {
    numWords: 0,
    voiceSeconds: 0.2,
    backoffSeconds: 1
  },
  monitorPlan: {
    listenEnabled: true,
    controlEnabled: true
  },
  transcriber: {
    language: 'en',
    smartFormat: true,
    // languageDetectionEnabled: false,
    keywords: [],
    endpointing: 10,
    // codeSwitchingEnabled: false
  },
  endCallFunctionEnabled: false,
  dialKeypadFunctionEnabled: false,
  forwardingPhoneNumber: null
};